<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="departmentnodeconfigTable" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			formrule: {
				default: () => {
					return {}
				}
			},
			configdata: {
				default: () => {
					return null
				}
			},
			
			
		},
		data() {
			return {
				modal_model:false,
				modal_title: '节点部门配置',
				modal_width:600,
				modal_height:500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {				
				let gradeDepartmentidOptions = this.formrule.rule.filter((item)=>{
					return item.field && item.field.endsWith('departmentid')
				})
				gradeDepartmentidOptions = gradeDepartmentidOptions.map((item)=>{
					return {
						value:item.field,
						label:item.title+'('+item.field+')',
					}
				})
				
				let gradeStaffidOptions = this.formrule.rule.filter((item)=>{
					return item.field && item.field.endsWith('staffid')
				})
				gradeStaffidOptions = gradeStaffidOptions.map((item)=>{
					return {
						value:item.field,
						label:item.title+'('+item.field+')',
					}
				})
				
				
				gridOptions.height = 'auto'
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'departmentnode',
						title: '节点部门',
						editRender: {
							name: '$department',
							props: {

							},
							events: {
								
							}
						},
					}, {
						field: 'gradeDepartmentid',
						title: '业务部门字段',
						editRender: {
							name: '$select',
							props: {
								selectoptions:gradeDepartmentidOptions
							},
							events: {
									
							}
						},
					}, {
						field: 'gradeStaffid',
						title: '业务员字段',
						editRender: {
							name: '$select',
							props: {
								selectoptions:gradeStaffidOptions
							},
							events: {
			
							}
						},
					}, {
						field: 'mode',
						title: '分级模式',
						editRender: {
							name: '$select',
							props: {
								selectoptions: [{
										value: 1,
										label: "普通模式"
									},
									{
										value: 2,
										label: "分级模式(严格)"
									},
									{
										value: 3,
										label: "分级模式(宽松)"
									},
									{
										value: 4,
										label: "分级模式(共享)"
									}
								],
							},
							events: {
			
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					departmentnode: [{
						required: true,
						message: '缺少必填项【节点部门】',
					}]
				}
			},
			list() {
				//console.log(this.parseJson(),this.configdata)
				return new Promise((resolve) => {
					resolve({
						list: this.parseJson()
					})
				})
			},
			getgrid(){
				return this.$refs.departmentnodeconfigTable
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			modal_init(){
	
				// let formData = JSON.parse(JSON.stringify(formjson))
				// let rule = formData.rule.rule
				// let option = formData.rule.option
				// option.el = this.$refs.logistictrace_custom_form
				//this.fApi = this.$formCreate(rule, option)
				// this.fApi.nextTick(() => {
				// 	this.regestevent(rule)
				// 	this.setFormData()		
				// })
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			submit() {
				this.getgrid().validate(true, (res) => {
					if (!res) {
						let data = this.getgrid().getTableData().tableData
						//console.log(data,8989)
						this.$emit('success', {
							data: data.length? JSON.stringify(data):null
						})				
						this.modal_cancel()
					} else {
						for (let i in res) {
							this.$message.error('缺少必填项：' + res[i][0].column.title)
						}
					}
				})
				
				
				

				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			},
			parseJson() {
				return this.configdata ? JSON.parse(this.configdata) : []
			},
		},
		components: {
			
		}
	}
</script>